import * as React from 'react';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEnvelope} from '@fortawesome/free-solid-svg-icons';

import {Asset} from '@deviceinsight/ng-ui-api-client';

import {getAssetDeviceType} from '../ruleengine/ruleEditHelpers';
import {ACTION_TYPE_DEVICE, DeviceType} from '../../modules/ruleengine/config/consts';
import sBoxIcon from '../../assets/sBoxIcon.svg';
import sLightIcon from '../../assets/sLightIcon.svg';
import kisIoIcon from '../../assets/kisIoIcon.svg';
import assetIcon from '../../assets/icon-asset.png';
import './DeviceAndActionIcon.less';
type Props = {
	small?: boolean;
	asset: Asset | null | undefined;
	type: 'EMAIL_ACTION' | 'DEVICE_ACTION' | 'unknown';
};
type DeviceIconProps = {
	deviceType: string;
};

const DeviceIcon = ({deviceType}: DeviceIconProps) => {
	switch (deviceType) {
		case DeviceType.sBox:
			return <img src={sBoxIcon} alt="sBox icon" />;

		case DeviceType.sLight:
			return <img src={sLightIcon} alt="sLight icon" />;

		case DeviceType.kisIo:
			return <img src={kisIoIcon} alt="kisIo icon" />;

		default:
			return <img src={assetIcon} alt="asset icon" />;
	}
};

const DeviceAndActionIcon: React.FC<Props> = ({asset, type, small}) => {
	const iconClass = classNames({
		rule_icon: true,
		small: small
	});

	if (asset && type === ACTION_TYPE_DEVICE) {
		const deviceType = getAssetDeviceType(asset);
		return (
			<span className={iconClass} data-testid="device-icon">
				<DeviceIcon deviceType={deviceType} />
			</span>
		);
	} else {
		return (
			<span className={iconClass} data-testid="action-icon">
				<FontAwesomeIcon icon={faEnvelope} />
			</span>
		);
	}
};

export default DeviceAndActionIcon;
